// extracted by mini-css-extract-plugin
export default {"pageWrap":"Na-z","fullWidth":"Oa-z","heading":"Pa-z","fullBleed":"Qa-z","hidden":"Ra-z"};